import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function NftDetailsEmbadedAssetsDialog(props) {
  const handleClose = () => {
    props.setdialogState(false);
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: 20,
        },
      }}
      disableScrollLock={false}
      style={{ zIndex: 999 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <div>
        <div
          className="dialog-titlebar dialog_borderBottom"
          style={{
            padding: '15px 20px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div className="dialog-title" style={{ fontSize: 20 }}>
            Embed code
          </div>
          <div style={{ marginLeft: 'auto', marginRight: 10 }}>
            <button
              className="text-black text-lg font-light rounded-full outline-none focus:outline-none border border-gray-300"
              type="button"
              onClick={handleClose}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div>
          <DialogContent
            style={{ minHeight: 300, maxHeight: 500, overflowY: 'auto' }}
          >
            <div className="flex justify-between copy_icn">
              <h2
                style={{
                  color: '#707a83',
                  fontSize: '16px',
                  fontWeight: '400',
                }}
              >
                To embed this asset, copy and paste the code below into your
                site
              </h2>
              <CopyToClipboard
                text={props.nftCode}
                onCopy={() => {
                  toast.success('Code copied!', {
                    position: 'bottom-left',
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    zIndex: 2147483641,
                  });
                }}
              >
                <a className="share__link share__link--link">
                  <i className="far fa-copy"></i>
                </a>
              </CopyToClipboard>
            </div>
            <blockquote className="share__code__wrapper">
              <code>{props.nftCode}</code>
            </blockquote>
          </DialogContent>
        </div>
      </div>
    </Dialog>
  );
}
